import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import firebase from 'firebase/app'
import 'firebase/auth'

// Page Components
import SignIn from '@/pages/SignIn'
import Home from '@/pages/Home'
import MyHours from '@/pages/MyHours'
import MyProfile from '@/pages/MyProfile'
import PreStart from '@/pages/PreStart'

import Test from '@/pages/Test'

Vue.use(Router)

let router = new Router({
  routes: [
    { path: '/sign-in', name: 'Sign In', component: SignIn }, { path: '/home', name: 'Home', component: Home, meta: { requiresAuth: true } },
    { path: '/my-hours', name: 'My Hours', component: MyHours, meta: { requiresAuth: true } },
    { path: '/my-profile', name: 'My Profile', component: MyProfile, meta: { requiresAuth: true } },
    { path: '/pre-start', name: 'Pre Start - Flick & Tick', component: PreStart, meta: { requiresAuth: true } },
    { path: '/employee-register', name: 'Employee Register', component: () => import('@/pages/EmployeeRegister'), meta: { requiresAuth: true, privilege: 'employee register' } },

    //
    { path: '/saturday-roster', name: 'Saturday Roster', component: () => import('@/pages/SaturdayRoster'), meta: { requiresAuth: true } },
    { path: '/leave', name: 'Leave', component: () => import('@/pages/Leave'), meta: { requiresAuth: true } },

    // INCIDENTS
    { path: '/incidents', name: 'Incidents', component: () => import('@/pages/Incidents'), meta: { requiresAuth: true } },
    { path: '/incidents/add', name: 'Add Incident', component: () => import('@/pages/AddIncident'), meta: { requiresAuth: true } },
    { path: '/incident/:id', name: 'Incident', component: () => import('@/pages/Incident'), meta: { requiresAuth: true } },
    { path: '/admin/incidents', name: 'Incidents Admin', component: () => import('@/pages/admin/AdminIncidents'), meta: { requiresAuth: true, privilege: 'admin' } },

    // MACHINE
    { path: '/machines', name: 'Machines', component: () => import('@/pages/Machines'), meta: { requiresAuth: true } },
    { path: '/view-machine/:id', name: 'Machine', component: () => import('@/pages/ViewMachine'), meta: { requiresAuth: true } },
    { path: '/view-machine-repairs/:id', name: 'Machine Repairs', component: () => import('@/pages/ViewMachineRepairs'), meta: { requiresAuth: true } },
    { path: '/view-machine-report/:id', name: 'Machine Report', component: () => import('@/pages/ViewMachineReport'), meta: { requiresAuth: true } },
    { path: '/add-machine', name: 'Add Machine', component: () => import('@/pages/AddMachine'), meta: { requiresAuth: true } },
    { path: '/edit-machine/:id', name: 'Edit Machine', component: () => import('@/pages/EditMachine'), meta: { requiresAuth: true } },
    { path: '/service/:id', name: 'Service', component: () => import('@/pages/Service'), meta: { requiresAuth: true } },
    { path: '/machine-hire', name: 'Machine Hire', component: () => import('@/pages/MachineHire'), meta: { requiresAuth: true } },

    // PRE START CHECKS ADMIN
    { path: '/check-lists', name: 'Check Lists', component: () => import('@/pages/CheckList/CheckLists'), meta: { requiresAuth: true } },
    { path: '/add-check-list', name: 'Add Check List', component: () => import('@/pages/CheckList/AddCheckList'), meta: { requiresAuth: true } },
    { path: '/edit-check-list/:id', name: 'Edit Check List', component: () => import('@/pages/CheckList/EditCheckList'), meta: { requiresAuth: true } },
    { path: '/view-check-list/:id', name: 'View Check List', component: () => import('@/pages/CheckList/ViewCheckList'), meta: { requiresAuth: true } },

    { path: '/user-settings', name: 'User Settings', component: () => import('@/pages/UserSettings'), meta: { requiresAuth: true } },
    { path: '/admin', name: 'Admin', component: () => import('@/pages/admin/AdminHome'), meta: { requiresAuth: true, privilege: 'admin' } },
    { path: '/admin-settings', name: 'Admin Settings', component: () => import('@/pages/admin/AdminSettings'), meta: { requiresAuth: true, privilege: 'admin' } },
    { path: '/admin/hours', name: 'Admin - Employee Hours', component: () => import('@/pages/admin/AdminHours'), meta: { requiresAuth: true, privilege: 'admin' } },

    // USER
    { path: '/admin/new-user', name: 'Admin - New User', component: () => import('@/pages/admin/NewUser'), meta: { requiresAuth: true, privilege: 'admin' } },
    { path: '/admin/users', name: 'Admin - Users', component: () => import('@/pages/admin/Users'), meta: { requiresAuth: true, privilege: 'admin' } },
    { path: '/admin/user/:uid', name: 'Admin - User', component: () => import('@/pages/admin/User'), meta: { requiresAuth: true, privilege: 'admin' } },

    { path: '/test', name: 'Test', component: Test, meta: { requiresAuth: true, privilege: 'admin' } }
  ],
  mode: 'history'
})

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if (!to.name) {
    next(currentUser ? 'home' : '/sign-in')
  } else if (requiresAuth && !currentUser) {
    next('/sign-in')
  } else if (requiresAuth && currentUser) {
    let user = store.getters.user
    if (user) {
      let priv = to.meta.privilege || ''
      if (!priv.length) {
        next()
        store.dispatch('setLastRouterPath', to.path)
        return
      }
      let privs = priv.split(', ')
      let userPrivs = user.privileges || []
      for (const p of privs) {
        if (userPrivs.includes(p)) {
          next()
          store.dispatch('setLastRouterPath', to.path)
          return
        }
      }

      alert('Cannot access page')
      next('home')
    } else {
      next()
    }
  } else {
    next()
  }

  store.dispatch('setLastRouterPath', to.path)
})

export default router
